import React from "react";
import PropTypes from "prop-types";
const BallBounceIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path d="M2 2h16v16H2z" />
      <g transform="translate(2 2.25)">
        <circle
          fill={color || "var(--color-easil-gray-x-dark)"}
          cx="13"
          cy="3"
          r="3"
        />
        <path
          d="M9 6.5c-1.772 1.72-2.772 3.053-3 4-1.366-3.725-3.032-6.391-5-8"
          stroke={color || "var(--color-easil-gray-x-dark)"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          fill={color || "var(--color-easil-gray-x-dark)"}
          y="13.5"
          width="16"
          height="2"
          rx="1"
        />
      </g>
    </g>
  </svg>
);
BallBounceIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default BallBounceIcon;
